import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { isString, singleColorRegex, isNullish, floatRegex } from '../utils.mjs';

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
var isColorString = function isColorString(type, testProp) {
  return function (v) {
    return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && !isNullish(v) && Object.prototype.hasOwnProperty.call(v, testProp));
  };
};
var splitColor = function splitColor(aName, bName, cName) {
  return function (v) {
    if (!isString(v)) return v;
    var _v$match = v.match(floatRegex),
      _v$match2 = _slicedToArray(_v$match, 4),
      a = _v$match2[0],
      b = _v$match2[1],
      c = _v$match2[2],
      alpha = _v$match2[3];
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, aName, parseFloat(a)), bName, parseFloat(b)), cName, parseFloat(c)), "alpha", alpha !== undefined ? parseFloat(alpha) : 1);
  };
};
export { isColorString, splitColor };